export default {
  titles: '"Montserrat", sans-serif, "Helvetica", sans-serif',
  paragraph:
    '"Inconsolata", monospace, source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace'
};
